export enum Permission {
  UsersRead = 'users.read',

  UsersManagementRead = 'users.management.read',
  UsersManagementCreate = 'users.management.create',
  UsersManagementUpdate = 'users.management.update',
  UsersManagementDelete = 'users.management.delete',
  UsersManagementHardDelete = 'users.management.hard-delete',

  EmployeesRead = 'employees.read',
  EmployeesCreate = 'employees.create',
  EmployeesUpdate = 'employees.update',
  EmployeesDelete = 'employees.delete',

  ClientsRead = 'clients.read',
  ClientsCreate = 'clients.create',
  ClientsUpdate = 'clients.update',
  ClientsDelete = 'clients.delete',

  CompaniesRead = 'companies.read',
  CompaniesCreate = 'companies.create',
  CompaniesUpdate = 'companies.update',
  CompaniesDelete = 'companies.delete',

  AffiliatesRead = 'affiliates.read',
  AffiliatesCreate = 'affiliates.create',
  AffiliatesUpdate = 'affiliates.update',
  AffiliatesDelete = 'affiliates.delete',

  CounsellingIntakeAssessmentRead = 'counselling-intake-assessments.read',
  CounsellingIntakeAssessmentUpdate = 'counselling-intake-assessments.update',
  RiskScreenerRead = 'risk-screeners.read',
  RiskScreenerCreate = 'risk-screeners.create',

  InterventionsRead = 'interventions.read',
  InterventionsUpdate = 'interventions.update',

  ReferralsRespond = 'referrals.respond',
  SessionsRecord = 'sessions.record',
  ConsentsRecord = 'consents.record',

  HangfireRead = 'hangfire.read',

  Admin = 'admin',
}
